import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, NoPreloading } from '@angular/router';
import { HomeComponent } from './Components/home/home.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    data: {
      title: 'Trinka - Grammar Checker For Academic & Technical Writing',
      description: 'Trinka is the only AI grammar checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      keywords: 'grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too'
    }
  },
  {
    path: 'enterprise',
    loadChildren: () =>
      import('./modules/enterprise/enterprise.module').then(m => m.EnterpriseModule)
  },
  {
    path: 'features',
    children: [
      {
        path: 'documark',
        loadChildren: () =>
          import('./modules/documark/documark.module').then(m => m.DocumarkModule)
      },
      {
        path: 'credits',
        loadChildren: () =>
          import('./modules/credits/credits.module').then(m => m.CreditsModule)
      },
      {
        path: 'ai-studio/ai-assisted-writing',
        loadChildren: () =>
          import('./modules/asktrinka/asktrinka.module').then(m => m.AsktrinkaModule)
      },
      {
        path: 'proofread-file',
        loadChildren: () =>
          import('./modules/auto-file-edit/auto-file-edit.module').then(m => m.AutoFileEditModule)
      },
      {
        path: 'paraphraser',
        loadChildren: () =>
          import('./modules/online-paraphraser/online-paraphraser.module').then(m => m.OnlineParaphraserModule)
      },
      {
        path: 'grammar-checker',
        loadChildren: () =>
          import('./modules/features-grammar-checker/features-grammar-checker.module').then(m => m.FeaturesGrammarCheckerModule)
      }
    ]
  },
  {
    path: 'local-invoice',
    loadChildren: () =>
      import('./modules/official-invoice/official-invoice.module').then(m => m.OfficialInvoiceModule)
  },
  {
    path: 'case-study',
    loadChildren: () =>
      import('./modules/case-study/case-study.module').then(m => m.CaseStudyModule)
  },
  {
    path: 'industry-engagements',
    loadChildren: () =>
      import('./modules/industry-engagements/industry-engagements.module').then(m => m.IndustryEngagementsModule)
  },
  {
    path: 'pricing',
    loadChildren: () =>
      import('./modules/pricing/pricing.module').then(m => m.PricingModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabled',
    scrollOffset: [0, 0],
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
